// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yNWU","footer":"styles_footer__5RWh8"};